import type { RoleConfig } from '../types.js';

export const executioner: RoleConfig = {
  id: 'executioner',
  faction: 'solo',
  title: { ru: 'Палач', uk: 'Кат' },
  latin: 'EXECUTIONER',
  number: '30',
  accent: '#a86a3a',
  ability: {
    ru: 'В начале игры узнаёт цель. Один раз за игру может ночью подставить любого, чтобы он выглядел мафией. Если цель повесят — побеждает; если её убьют ночью — превращается в шута.',
    uk: 'На початку гри дізнається ціль. Один раз за гру може вночі підставити будь-кого, щоб виглядав мафією. Якщо ціль повісять — перемагає; якщо її вб’ють вночі — стає блазнем.',
  },
  abilities: [
    { key: 'frame', phase: 'night', cadence: 'one-time', charges: 1 },
  ],
  victory: { type: 'solo-target-voted' },
};
